export default (function () {
  // DOM picks
  var menu = document.querySelector('.o-menu__wrapper');
  var button = menu ? menu.querySelector(".js-toggle-menu") : null;

  // utils
  var className = 'o-menu__wrapper--isVisible';
  var isMobile = window.matchMedia("(max-width: 679px)");
  var isActive = false;

  // handlers
  var activate = function activate() {
    button.setAttribute("aria-expanded", true);
    menu.classList.add(className);
    isActive = true;
  };
  var deactivate = function deactivate() {
    button.setAttribute("aria-expanded", false);
    menu.classList.remove(className);
    isActive = false;
  };

  // init
  if (!isMobile.matches && button != null) activate();

  // listeners
  isMobile.addEventListener("change", function (event) {
    return event.matches ? deactivate() : activate();
  });
  if (button) {
    button.addEventListener('click', function () {
      return isActive ? deactivate() : activate();
    });
  }
  ;
});